import { Check, ShieldCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { CtaButton } from "./CtaButton";
import { Sprig } from "./Botanical";

const INCLUDES = [
    "Digital PDF",
    "Instant access",
    "5-day guided format",
    "Simple exercises",
    "Relationship Energy Leak check",
    "Mobile-friendly",
];

export const Offer = () => (
    <section className="relative bg-blush/60 py-16 sm:py-24" data-testid="offer-section">
        <div className="mx-auto max-w-2xl px-5 sm:px-8">
            <Reveal>
                <div
                    className="rounded-[2rem] bg-gradient-to-br from-goldlight/80 via-gold/40 to-goldlight/80 p-[2px] shadow-2xl shadow-plum/20"
                    data-testid="offer-card"
                >
                    <div className="relative overflow-hidden rounded-[calc(2rem-2px)] bg-white px-6 py-10 sm:px-10 sm:py-12">
                        <Sprig className="pointer-events-none absolute -right-3 -top-2 w-12 rotate-[25deg] text-gold/25" />
                        <Sprig className="pointer-events-none absolute -left-3 bottom-0 w-12 rotate-[195deg] text-gold/20" />

                        <div className="relative text-center">
                            <h2 className="font-serif text-2xl font-medium text-plum sm:text-3xl">
                                Start Your 5-Day Reset Today
                            </h2>
                            <p className="mt-2 font-sans text-[0.65rem] font-bold uppercase tracking-[0.26em] text-burgundy">
                                5-Day Husband Reset Guide
                            </p>

                            <div
                                className="mt-8 flex items-end justify-center gap-3"
                                data-testid="offer-price-row"
                            >
                                <span className="mb-2 font-sans text-lg text-mutedtext/70 line-through" data-testid="offer-original-price">
                                    &#8377;199
                                </span>
                                <span className="font-serif text-5xl font-medium text-plum sm:text-6xl" data-testid="offer-price">
                                    &#8377;49
                                </span>
                                <span className="mb-2 font-sans text-[0.65rem] font-extrabold uppercase tracking-[0.2em] text-gold">
                                    Only
                                </span>
                            </div>

                            <ul
                                className="mx-auto mt-9 grid max-w-md grid-cols-1 gap-x-6 gap-y-3 text-left sm:grid-cols-2"
                                data-testid="offer-includes-list"
                            >
                                {INCLUDES.map((item) => (
                                    <li key={item} className="flex items-center gap-2.5 text-[0.92rem] text-ink">
                                        <Check className="h-4 w-4 shrink-0 text-gold" strokeWidth={3} />
                                        {item}
                                    </li>
                                ))}
                            </ul>

                            <div className="mt-10">
                                <CtaButton
                                    testId="offer-cta-button"
                                    variant="gold"
                                    className="w-full px-8 py-5 text-sm sm:w-auto"
                                >
                                    Get My Guide For &#8377;49
                                </CtaButton>
                            </div>

                            <p
                                className="mt-5 inline-flex items-center gap-2 font-sans text-[0.7rem] font-medium uppercase tracking-[0.16em] text-mutedtext"
                                data-testid="offer-security-note"
                            >
                                <ShieldCheck className="h-4 w-4 text-gold" />
                                Secure payment &bull; Instant digital access
                            </p>
                        </div>
                    </div>
                </div>
            </Reveal>
            <Reveal delay={0.1}>
                <p className="mt-6 text-center text-sm text-mutedtext" data-testid="consultation-whatsapp-line">
                    Have questions?{" "}
                    <a
                        href={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMBER}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-semibold text-burgundy underline decoration-gold decoration-2 underline-offset-4 transition-colors hover:text-plum"
                        data-testid="consultation-whatsapp-link"
                    >
                        WhatsApp us on 85109 13703
                    </a>{" "}
                    for further consultation.
                </p>
            </Reveal>
        </div>
    </section>
);

export default Offer;
